let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hf003")).then(() => parcelRequire('97DO0'));